<template>
  <div>
    <v-dialog v-model="dialog" max-width="520px">
      <template v-slot:activator="{ on }">
        <v-list-item v-on="on">
          <v-list-item-title>Change Status</v-list-item-title>
        </v-list-item>
      </template>

      <v-card class="status-card">
        <div class="status-header">
          <div>
            <div class="status-title">Order Status</div>
            <div class="status-subtitle">
              Order #{{ order.localId }}
            </div>
          </div>

          <v-btn icon small @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-4">
          <div class="order-summary">
            <div class="order-avatar">
              {{ customerInitial }}
            </div>

            <div class="order-info">
              <div class="customer-name">
                {{ customerName }}
              </div>

              <div class="order-meta">
                Created {{ order.date | moment("MM/DD/YYYY") }}
              </div>

              <div class="order-meta">
                Viewed:
                <span v-if="order.read">
                  {{ order.read | moment("MM/DD/YYYY") }}
                </span>
                <span v-else>Not viewed yet</span>
              </div>

              <div class="order-meta" v-if="order.User">
                User: {{ order.User.name }}
              </div>
            </div>

            <div class="order-total">
              {{ order.total | currency }}
            </div>
          </div>

          <div class="status-section">
            <div class="field-label">Status</div>

            <v-btn-toggle
              v-model="selection"
              mandatory
              dense
              class="status-toggle"
            >
              <v-btn :value="0">
                Pending
              </v-btn>

              <v-btn :value="1">
                Complete
              </v-btn>
            </v-btn-toggle>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="status-actions">
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            rounded
            dark
            :loading="loading"
            @click="saveOrder"
          >
            Save Status
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import orderService from "@/modules/Order/components/InHouse/service.js";

export default {
  name: "order-status",

  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dialog: false,
      loading: false,
      selection: 0,
    };
  },

  computed: {
    customerName() {
      if (this.order.Customer && this.order.Customer.name) {
        return this.order.Customer.name;
      }

      if (this.order.metadata && this.order.metadata.publicCustomer) {
        return (
          this.order.metadata.publicCustomer.businessName ||
          this.order.metadata.publicCustomer.name ||
          "Unknown Customer"
        );
      }

      return "Unknown Customer";
    },

    customerInitial() {
      return this.customerName ? this.customerName.charAt(0).toUpperCase() : "?";
    },
  },

  methods: {
    saveOrder() {
      if (this.selection !== 1) {
        this.dialog = false;
        this.$emit("submit");
        return;
      }

      this.loading = true;

      return orderService
        .updateStatus(this.order.id, {
          completeDate: new Date(),
          status: "completed",
        })
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Order is completed!",
            });

          this.dialog = false;
          this.$emit("submit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.status-card {
  border-radius: 20px;
  overflow: hidden;
}

.status-header {
  padding: 16px 18px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.status-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
}

.status-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.order-summary {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #f8fafc;
  border-radius: 18px;
  padding: 14px;
}

.order-avatar {
  width: 46px;
  height: 46px;
  min-width: 46px;
  border-radius: 16px;
  background: #eff6ff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}

.order-info {
  min-width: 0;
  flex: 1;
}

.customer-name {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
}

.order-meta {
  font-size: 12px;
  color: #64748b;
  margin-top: 3px;
}

.order-total {
  font-size: 17px;
  font-weight: 900;
  color: #0f172a;
  white-space: nowrap;
}

.status-section {
  margin-top: 18px;
}

.field-label {
  font-size: 12px;
  font-weight: 800;
  color: #475569;
  margin-bottom: 8px;
}

.status-toggle {
  background: #f8fafc;
  border-radius: 14px;
  padding: 3px;
}

.status-toggle .v-btn {
  min-width: 120px;
}

.status-actions {
  padding: 12px 16px;
}

@media (max-width: 600px) {
  .order-summary {
    align-items: flex-start;
  }

  .order-total {
    font-size: 15px;
  }

  .status-toggle {
    width: 100%;
  }

  .status-toggle .v-btn {
    flex: 1;
    min-width: 0;
  }
}
</style>